// extracted by mini-css-extract-plugin
export default {"menuWrap":"MobileMenu_menuWrap__VdJTb","defiLlamButton":"MobileMenu_defiLlamButton__mlgEO","menu":"MobileMenu_menu__2554j"};